import axios from 'axios'
import React from 'react'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router-dom'
import { GalleryFeatured } from './GalleryFeatured'
import { GalleryShowcase } from './GalleryShowcase'
import { GalleryListView } from './GalleryListView'
import { Footer } from './Footer'
import { Topnav } from '../core/Topnav'
import LoadingAnimation from '../core/LoadingAnimation'

const Gallery = () => {
  const [mintedSongs, setMintedSongs] = React.useState([])
  const [mintedSongsLoaded, setMintedSongsLoaded] = React.useState(false)
  const [selectedSong, setSelectedSong] = React.useState(null)
  const [initialLoad, setInitialLoad] = React.useState(true)
  const location = useLocation()
  const search_params = new URLSearchParams(location.search)

  const playNextSong = () => {
    setInitialLoad(false)
    if (selectedSong < mintedSongs.length - 1) setSelectedSong(selectedSong + 1)
  }

  const playPreviousSong = () => {
    setInitialLoad(false)
    if (selectedSong > 0) setSelectedSong(selectedSong - 1)
  }

  React.useEffect(() => {
    document.title = 'Listen'

    axios
      .get('/api/v1/genesis-songs/all')
      .then((resp) => resp.data)
      .then((data) => {
        setMintedSongs(
          data.sort(
            (first, second) => Number(second.metadata.mint_time) - Number(first.metadata.mint_time)
          )
        )
        let selected_song_index = Math.floor(Math.random() * data.length)
        if (search_params.has('song')) {
          const selected_song_id = search_params.get('song')
          for (let i = 0; i < data.length; i++) {
            if (data[i].song === selected_song_id) {
              selected_song_index = i
              break
            }
          }
        }
        setSelectedSong(selected_song_index)
      })

    ReactGA.pageview(window.location.pathname)
  }, [])

  return (
    <div className="gallery-main">
      <div>
        <div className="container overflow-x-hidden">
          <Topnav />
          <div className="row" style={{ paddingTop: '80px', paddingBottom: '86px' }}>
            <div className="col-12">
              {selectedSong !== null ? (
                <GalleryFeatured
                  item={mintedSongs[selectedSong]}
                  initialLoad={initialLoad}
                  playNextSong={playNextSong}
                  playPreviousSong={playPreviousSong}
                />
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: '60vh' }}
                >
                  <LoadingAnimation />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="gallery-lower-section">
        <div className="container overflow-x-hidden">
          <div className="row" style={{ paddingTop: '48px', paddingBottom: '48px' }}>
            <div className="col-12">
              <GalleryListView
                mintedSongs={mintedSongs}
                setSelectedSong={(song) => {
                  setSelectedSong(song)
                  setInitialLoad(false)
                }}
                selectedSong={selectedSong}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Gallery
